import axios from 'axios'
import { EXCLUIR_ROTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirRota (cod, idEmpresa) {
  const url = `${URL}/rota/${cod}/empresa/${idEmpresa}/excluir/`;
  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_ROTA,
        payload: response
      })
  );
}
